import axios from 'axios';
import { getEnvConfig } from 'configuration/envConfig';

const instance = axios.create({
  baseURL: getEnvConfig('REACT_APP_BASE_URL_API') + 'api/',
});

export default instance;
